<template>
    <div>
        <div class="mb-5">
            <h3>Stores</h3>
            <div>
                <div class="row">
                    <div class="col-5">
                        <label>Store-UUID</label>
                    </div>
                    <div class="col-3">
                        <label>Name (Abkürzung)</label>
                    </div>
                    <div class="col-3">
                        <label>ID in Feed</label>
                    </div>
                </div>
                <div v-for="store in stores" class="row mt-2">
                    <div class="col-5">
                        <input class="form-control" type="text" placeholder="Store-UUID" v-model="store.store_uuid"
                               required>
                    </div>
                    <div class="col-3">
                        <input class="form-control" type="text" placeholder="Name"
                               v-model="store.name" required>
                    </div>
                    <div class="col-3">
                        <input class="form-control" type="text" placeholder="Händler Store-ID"
                               v-model="store.store_identifier"
                               :disabled="storeCount === 1">
                    </div>
                    <div class="col-1">
                        <button class="btn btn-light-danger" :disabled="storeCount === 1" @click="removeStore(store)">
                            Entfernen
                        </button>
                    </div>
                </div>
                <div class="row">
                    <div class="col-5">
                        <span class="form-text text-muted">Die UUID des Stores.</span>
                    </div>
                    <div class="col-3">
                        <span
                            class="form-text text-muted">Ein eindeutige Abkürzung. Wird zum ausführen verwendet.</span>
                    </div>
                    <div class="col-3">
                        <span class="form-text text-muted">Wird nur verwendet, wenn mehr als ein Store pro Feed vorhanden sind.</span>
                    </div>
                </div>
            </div>
            <div class="mt-3">
                <button class="btn btn-default" @click="addStore()"><i class="fas fa-plus-square"></i> Store hinzufügen
                </button>
            </div>
        </div>

        <hr>

        <div class="my-5">
            <h3>Feed Einstellungen</h3>
            <div>
                <div class="row">
                    <div class="col-6 col-md-3">
                        <label>Delimiter</label>
                        <input class="form-control" type="text" placeholder="Delimiter" maxlength="1"
                               v-model="form.delimiter">
                        <span class="form-text text-muted">Das Trennzeichen der CSV. Für Tab "t" eingeben.</span>
                    </div>
                    <div class="col-6 col-md-3">
                        <label>Enclosure</label>
                        <input class="form-control" type="text" placeholder="Enclosure" maxlength="1"
                               v-model="form.enclosure">
                        <span class="form-text text-muted">Falls Texte umschlossen werden, wird das Zeichen hier angegeben.</span>
                    </div>
                    <div class="col-6 col-md-3">
                        <label>Header Offset</label>
                        <input class="form-control" type="number" placeholder="Header Offset"
                               v-model="form.header_offset">
                        <span class="form-text text-muted">Der Abstand zur Zeile mit den Überschriften.</span>
                    </div>
                    <div class="col-6 col-md-3">
                        <label>Spaltennamen</label>
                        <div class="checkbox-inline">
                            <label class="checkbox checkbox-lg">
                                <input type="checkbox" v-model="form.no_column_names">
                                <span></span>Keine Spaltennamen</label>
                        </div>
                        <span class="form-text text-muted">Gibt an ob die Spalten der CSV benannt sind.</span>
                    </div>
                </div>
                <div class="row mt-5">
                    <div class="col-6 col-md-3">
                        <label>GTIN-Spalte</label>
                        <input class="form-control" type="text" placeholder="EAN-Spalte" v-model="form.header_map.gtin">
                        <span class="form-text text-muted">{{ columnType }} der EAN/GTIN Spalte.</span>
                    </div>
                    <div class="col-6 col-md-3">
                        <label>Preis-Spalte</label>
                        <input class="form-control" type="text" placeholder="Preis-Spalte"
                               v-model="form.header_map.price">
                        <span class="form-text text-muted">{{ columnType }} der Preis Spalte.</span>
                    </div>
                    <div class="col-6 col-md-3">
                        <label>Bestand-Spalte</label>
                        <input class="form-control" type="text" placeholder="Bestand-Spalte"
                               v-model="form.header_map.quantity">
                        <span class="form-text text-muted">{{ columnType }} der Spalte mit dem Bestand.</span>
                    </div>
                    <div class="col-6 col-md-3">
                        <label>Store-ID-Spalte</label>
                        <input class="form-control" type="text" placeholder="Store-ID-Spalte"
                               v-model="form.header_map.store_identifier"
                               :disabled="storeCount === 1">
                        <span class="form-text text-muted">{{ columnType }} der Store-ID Spalte. Wird nur verwendet, bei mehreren Stores pro Feed.</span>
                    </div>
                </div>
                <div class="row mt-5">
                    <div class="col-6 col-md-3">
                        <label>Benutzerdefinierte Artikelbezeichnung</label>
                        <input class="form-control" type="text" placeholder="Custom-Artikel-Id-Spalte" v-model="form.header_map.in_store_article_id">
                        <span class="form-text text-muted">Benutzerdefinierte Artikel ID für Ihr Geschäft</span>
                    </div>
                </div>
            </div>
        </div>

        <hr>

        <div class="mt-5">
            <h3>Quelle</h3>
            <div class="row">
                <div class="col">
                    <div class="form-group">
                        <label>Typ</label>
                        <div></div>
                        <select class="custom-select form-control" v-model="form.source">
                            <option disabled selected="selected">Bitte wählen Sie eine Quelle</option>
                            <option value="ftp">FTP</option>
                            <option value="url">URL</option>
                            <option value="manually">Manuell</option>
                        </select>
                    </div>
                </div>
            </div>
            <div class="row" v-if="form.source === 'url'">
                <div class="col">
                    <label>Feed-URL</label>
                    <input class="form-control" type="text" placeholder="https://..." v-model="form.url">
                    <span class="form-text text-muted">Die URL zum CSV download.</span>
                </div>
            </div>
            <div class="row" v-if="form.source === 'ftp'">
                <div class="col-6 col-md-3">
                    <label>Host</label>
                    <input class="form-control" type="text" placeholder="ftp.storeplus.de" v-model="form.host">
                    <span class="form-text text-muted">Die Adresse des FTP-Servers.</span>
                </div>
                <div class="col-6 col-md-2">
                    <label>User</label>
                    <input class="form-control" type="text" placeholder="User" v-model="form.user">
                    <span class="form-text text-muted">Der FTP-User.</span>
                </div>
                <div class="col-6 col-md-2">
                    <label>Passwort</label>
                    <input class="form-control" type="text" placeholder="Passwort" v-model="form.password">
                    <span class="form-text text-muted">Das Passwort des Users.</span>
                </div>
                <div class="col-6 col-md-3">
                    <label>Verzeichnis</label>
                    <input class="form-control" type="text" placeholder="Verzeichnis" v-model="form.ftp_dir">
                    <span class="form-text text-muted">Der Name des Ordners in /ftp auf web7.</span>
                </div>
                <div class="col-6 col-md-2">
                    <label>Dateien</label>
                    <input class="form-control" type="text" placeholder="Verzeichnis" v-model="form.files">
                    <span class="form-text text-muted">Die Anzahl der Feeds die eingelesen werden.</span>
                </div>
            </div>
        </div>

        <div class="mt-5 text-danger" v-if="errors !== {}">
            <div v-for="(items, error) in errors">
                <strong>{{ error }}</strong><br>
                <div v-for="e in items">{{ e }}</div>
            </div>
        </div>

        <div class="mt-5 pt-3">
            <button class="btn btn-primary" :class="{'spinner spinner-white spinner-left': loading}" @click="submit">
                Connectoren aktualisieren
            </button>
        </div>
    </div>
</template>

<script>
export default {
    name: 'EditConnector',

    props: {
        initStores: Array,
        settings: Object,
    },

    data() {
        return {
            loading: false,
            errors: {},
            stores: [],
            form: {
                delimiter: ';',
                enclosure: '',
                header_offset: 0,
                files: 1,
                no_column_names: true,
                source: 'ftp',
                host: '',
                user: '',
                password: '',
                ftp_dir: '',
                url: '',
                header_map: {
                    gtin: 'ean',
                    price: 'price',
                    quantity: 'quantity',
                    store_identifier: 'store_id',
                    in_store_article_id: 'in_store_article_id'
                },
            },
        }
    },

    mounted() {
        this.$nextTick(() => {
            if (this.initStores.length > 0) {
                this.stores = this.initStores
            } else {
                this.addStore()
            }
            if (this.settings !== null) {
                this.form = this.settings
            }
        })
    },

    computed: {
        storeCount: function() {
            return this.stores.length
        },
        columnType: function() {
            return this.form.no_column_names ? 'Index' : 'Name'
        },
    },

    methods: {
        addStore() {
            this.stores.push({store_uuid: '', name: '', store_identifier: ''})
        },

        removeStore(storeToRemove) {
            if (this.stores.length === 1) {
                return
            }

            let stores = []
            for (let store of this.stores) {
                if (storeToRemove !== store) {
                    stores.push(store)
                }
            }
            this.stores = stores
        },

        async submit() {
            if (this.loading) {
                return
            }

            this.errors = {}
            this.loading = true
            await axios.post(route('connectors.update'), {
                stores: this.stores,
                form: this.form,
            }, {
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                },
            }).then(data => {
                toastr.success('Connectoren aktualisiert.')
                window.location = route('connectors.index')
            }).catch(error => {
                toastr.error("Es traten fehler auf.");
                this.errors = error.response.data.errors
            })
            this.loading = false
        },
    },
}
</script>
